// removed by extract-text-webpack-plugin
module.exports = {"stage":"_3T2rH","icon":"NjZ57","complete":"_2lUh3","current":"_37gZm","title":"_25ks0","incomplete":"_31Lbm","wrapper":"_1ZqAQ"};


//////////////////
// WEBPACK FOOTER
// ./components/StageIndicator/styles.scss
// module id = 744
// module chunks = 0